import styled from 'styled-components';

const ButtonContainer = styled.div`
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 70px;
`

export default ButtonContainer;